// src/Layout.tsx
import PropTypes3 from "prop-types";

// src/Regions.tsx
import PropTypes2 from "prop-types";

// src/Region.tsx
import PropTypes from "prop-types";

// src/ComponentTag.ts
var ComponentTag_default = (component) => component && component.path ? `						
							<!--# COMPONENT ${component.path} -->` : null;

// src/Region.tsx
var Region = ({
  name,
  regionData,
  tag,
  addClass
}) => {
  if (!(name || "").trim()) {
    console.error(`<Region NO_NAME> name: ${JSON.stringify(name)}`);
    throw Error(`Can't render <Region> without a 'name' prop.`);
  }
  if (!regionData || typeof regionData !== "object" || !Object.keys(regionData).length) {
    console.error(`<Region "${name}"> regionData: ${JSON.stringify(regionData)}`);
    throw Error(`Can't render <Region "${name}"> without a 'regionData' prop.`);
  }
  const TAG = tag || "div";
  return /* @__PURE__ */ React.createElement(
    TAG,
    {
      "data-portal-region": name,
      className: "xp-region" + (addClass ? ` ${addClass}` : ""),
      dangerouslySetInnerHTML: {
        __html: `					${regionData.components && regionData.components.length > 0 ? regionData.components.map((component) => ComponentTag_default(component)).join("\n") : ""}					
`
      }
    }
  );
};
Region.propTypes = {
  name: PropTypes.string.isRequired,
  regionData: PropTypes.shape({
    components: PropTypes.arrayOf(PropTypes.shape({
      path: PropTypes.string.isRequired
    }))
  }).isRequired,
  tag: PropTypes.string,
  addClass: PropTypes.string
};
var Region_default = Region;

// src/Regions.tsx
var Regions = ({
  regionsData,
  names,
  tags,
  classes
}) => {
  if (!regionsData || typeof regionsData !== "object") {
    console.error("<Regions> regions: " + JSON.stringify(regionsData));
    throw Error("Can't render <Regions> without a 'regionsData' prop.");
  }
  const selectedRegions = !names ? Object.keys(regionsData) : typeof names === "string" ? [names] : Array.isArray(names) ? names : null;
  if (!selectedRegions) {
    console.error("<Regions> names: " + JSON.stringify(names));
    throw Error("Can't render <Regions>: 'names' prop must be a string, an array of strings or omitted/falsy.");
  }
  return selectedRegions.map(
    (name) => (
      //@ts-ignore
      /* @__PURE__ */ React.createElement(
        Region_default,
        {
          key: name,
          regionData: regionsData[name],
          name,
          tag: typeof tags === "string" ? tags : (tags || {})[name],
          addClass: classes === true ? name : typeof classes === "string" ? classes : (classes || {})[name]
        }
      )
    )
  );
};
Regions.propTypes = {
  regionsData: PropTypes2.objectOf(
    PropTypes2.shape({
      components: PropTypes2.arrayOf(
        PropTypes2.shape({
          path: PropTypes2.string.isRequired
        })
      )
    })
  ).isRequired,
  names: PropTypes2.oneOfType([
    PropTypes2.string,
    PropTypes2.arrayOf(
      PropTypes2.string
    )
  ]),
  tags: PropTypes2.oneOfType([
    PropTypes2.string,
    PropTypes2.objectOf(
      PropTypes2.string
    )
  ]),
  classes: PropTypes2.oneOfType([
    PropTypes2.bool,
    PropTypes2.string,
    PropTypes2.objectOf(
      PropTypes2.string
    )
  ])
};
var Regions_default = Regions;

// src/Layout.tsx
var Layout = ({
  regionsData,
  regionNames,
  regionClasses,
  containerTag,
  containerClass,
  children,
  childrenAfterRegions
}) => {
  const TAG = containerTag || "div";
  return /* @__PURE__ */ React.createElement(TAG, { className: containerClass }, !childrenAfterRegions ? children : null, regionsData ? /* @__PURE__ */ React.createElement(Regions_default, { regionsData, classes: regionClasses, names: regionNames }) : null, childrenAfterRegions ? children : null);
};
Layout.propTypes = {
  regionsData: PropTypes3.objectOf(
    PropTypes3.shape({
      components: PropTypes3.arrayOf(
        PropTypes3.shape({
          path: PropTypes3.string.isRequired
        })
      )
    })
  ),
  regionNames: PropTypes3.oneOfType([
    PropTypes3.string,
    PropTypes3.arrayOf(PropTypes3.string)
  ]),
  regionClasses: PropTypes3.oneOfType([
    PropTypes3.bool,
    PropTypes3.string,
    PropTypes3.objectOf(PropTypes3.string)
  ]),
  containerTag: PropTypes3.string,
  containerClass: PropTypes3.string,
  childrenAfterRegions: PropTypes3.bool
};
var Layout_default = Layout;

// src/Page.tsx
import PropTypes4 from "prop-types";
var Page = ({
  title,
  regionsData,
  regionNames,
  regionClasses,
  children,
  childrenAfterRegions
}) => {
  return [
    /* @__PURE__ */ React.createElement("head", null, title ? /* @__PURE__ */ React.createElement("title", null, title) : null),
    /* @__PURE__ */ React.createElement("body", { className: "xp-page" }, !childrenAfterRegions ? children : null, regionsData ? /* @__PURE__ */ React.createElement(Regions_default, { regionsData, classes: regionClasses, names: regionNames }) : null, childrenAfterRegions ? children : null)
  ];
};
Page.propTypes = {
  title: PropTypes4.string,
  regionsData: PropTypes4.objectOf(
    PropTypes4.shape({
      components: PropTypes4.arrayOf(
        PropTypes4.shape({
          path: PropTypes4.string.isRequired
        })
      )
    })
  ),
  regionNames: PropTypes4.oneOfType([
    PropTypes4.string,
    PropTypes4.arrayOf(PropTypes4.string)
  ]),
  regionClasses: PropTypes4.oneOfType([
    PropTypes4.bool,
    PropTypes4.string,
    PropTypes4.objectOf(PropTypes4.string)
  ]),
  childrenAfterRegions: PropTypes4.bool
};
var Page_default = Page;
export {
  ComponentTag_default as ComponentTag,
  Layout_default as Layout,
  Page_default as Page,
  Region_default as Region,
  Regions_default as Regions
};
